module.exports = __webpack_public_path__ + "311d81961c5880647fec7eaca1221b2a.woff2";